module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/1-0bc573364d2e3f82c4053a4aa96904dd.svg";